import { FiltroDeCapaDaNota } from "@/models"
import { Inject } from "inversify-props"
import type { CapaDaNotaServiceAdapter } from ".."

export class DownloadNotasUseCase {

	@Inject('CapaDaNotaServiceAdapter')
	private capaDaNotaServiceAdapter!: CapaDaNotaServiceAdapter

	getXmlsCompletos = async (params: FiltroDeCapaDaNota) => {

		const xmls = await this.capaDaNotaServiceAdapter.getXmlsCompletos(params)

		return xmls
	}
}